import {
  emitter,
  MODEL_VIEWED,
  PRODUCT_ADDED_TO_CART,
  PRODUCT_FAVOURITED,
  PRODUCT_UNFAVOURITED,
} from '@phoenix/event-bus';
import { BRAZE_EVENTS } from './constants';

const initializeBrazeListeners = () => {
  emitter.on(PRODUCT_ADDED_TO_CART, (data) => {
    window.brazeDataLayer.push({
      eventName: BRAZE_EVENTS.webCartProductAdded,
      properties: {
        internalReference: data.extraData?.internalReference ?? '',
        reference: data.reference ?? '',
      },
    });
  });

  emitter.on(PRODUCT_FAVOURITED, (data) => {
    window.brazeDataLayer.push({
      eventName: BRAZE_EVENTS.webProductFavourited,
      properties: data,
    });
  });

  emitter.on(PRODUCT_UNFAVOURITED, (data) => {
    window.brazeDataLayer.push({
      eventName: BRAZE_EVENTS.webProductUnfavourited,
      properties: data,
    });
  });

  emitter.on(MODEL_VIEWED, (data) => {
    window.brazeDataLayer.push({
      eventName: BRAZE_EVENTS.webModelViewed,
      properties: data,
    });
  });
};

initializeBrazeListeners();
